import axios from "axios";
import React, { useEffect, useState } from "react";
import { getHeader } from "../../../service/auth";
import { useLocation, useNavigate } from "react-router-dom";
import Bilan from "../../questionnaire/Bilan";
import { Button, Box, Paper } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useSnackContext } from "../../../components/SnackContext";
import SnackAlert from "../../../components/SnackAlert";
import BreadcrumbNav from "../../../components/BreadcrumbNav";
import PageTransition from "../../../components/PageTransition";
import { TouchFeedback } from "../../../components/RippleEffect";
import { BounceClick } from "../../../components/MicroInteractions";
import themeNutriFast from "../../../styles/NutriFastColors";

const BilanAdmin = () => {
  const headers = getHeader();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [valide, setValide] = useState(0);
  const [hasData, setHasData] = useState(false);
  const [data, setData] = useState({})
  const [steps, setSteps] = useState([]);
  const { alert, handleClose, setAlert } = useSnackContext();

  // Fil d'Ariane
  const breadcrumbItems = [
    { label: 'Accueil', path: '/' },
    { label: 'Gestion des utilisateurs', path: '/admin/gestion_user' },
    {
      label: `Questionnaires de ${state?.userName || 'l\'utilisateur'}`,
      path: '/admin/user/show',
      state: { id: state?.user_id, name: state?.userName }
    },
    { label: state?.quest?.name || 'Questionnaire', path: null }
  ];


  useEffect(() => {
    axios
      .get(process.env.REACT_APP_ADMIN + "/questionnaire/user/data/" + state.user_id + "/" + state.quest.id, {
        headers,
      })
      .then(({ data }) => {


        if (data.length > 0) {
          setData({ data: data[0] })
          setValide(data[0]["valide"]);
          setHasData(true);
        }

        // }
      });

    axios
      .get(process.env.REACT_APP_QUESTIONNAIRE + "/" + state.quest.id, { headers })
      .then(({ data }) => {
        setSteps(data);
      });
  }, []);

  const invalidate = () => {
    axios
      .get(
        process.env.REACT_APP_ADMIN + "/invalidate/" + state.quest.id + "/" + state.user_id,
        { headers }
      )
      .then(() => {
        setAlert({
          message: "Questionnaire invalidé",
          severity: "success",
          open: true,
        });
      });
  }

  const removeLine = () => {
    axios
      .delete(
        process.env.REACT_APP_ADMIN + "/quest/" + state.quest.id + "/" + state.user_id,
        { headers }
      )
      .then(() => {
        setHasData(false);
        setAlert({
          message: "Vous avez supprimé les réponses de ce volontaire",
          severity: "success",
          open: true,
        });
      });
  }

  return (
    <PageTransition>
      <Box sx={{ p: 3, maxWidth: 1400, mx: 'auto' }}>
        <BreadcrumbNav items={breadcrumbItems} />

        <BounceClick>
          <TouchFeedback>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={() => navigate('/admin/user/show', {
                state: { id: state?.user_id, name: state?.userName }
              })}
              sx={{
                color: themeNutriFast.palette.primary.dark,
                borderColor: themeNutriFast.palette.primary.dark,
                mb: 3,
                '&:hover': {
                  backgroundColor: 'rgba(2, 62, 138, 0.04)',
                  borderColor: themeNutriFast.palette.primary.main
                }
              }}
            >
              Retour aux questionnaires
            </Button>
          </TouchFeedback>
        </BounceClick>

        {hasData ? (
          <>
            <Bilan data={data} steps={steps} admin={true} state={state} />

            <Box sx={{ display: 'flex', gap: 2, mt: 3, justifyContent: 'center' }}>
              <Button
                variant="outlined"
                color="warning"
                onClick={invalidate}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(237, 108, 2, 0.04)'
                  }
                }}
              >
                Invalider le questionnaire
              </Button>

              <Button
                variant="outlined"
                color="error"
                onClick={removeLine}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(211, 47, 47, 0.04)'
                  }
                }}
              >
                Supprimer toutes les réponses
              </Button>
            </Box>

            <SnackAlert
              open={alert.open}
              severity={alert.severity}
              message={alert.message}
              handleClose={handleClose}
            />
          </>
        ) : (
          <Paper sx={{ p: 4, textAlign: 'center', color: '#666' }}>
            <div>Le volontaire n'a pas encore validé son questionnaire</div>
            {steps.length > 0 && (
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => navigate("/admin/edit/quest", {
                  state: { steps: JSON.parse(steps[0].form), data: {}, info: state }
                })}
              >
                Remplir le questionnaire
              </Button>
            )}
          </Paper>
        )}
      </Box>
    </PageTransition>
  );
};

export default BilanAdmin;
